import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";
import { PageTitleProps } from "types";

const TITLE_SX: SxProps<Theme> = { mb: "1.5rem", fontSize: "1.5rem", fontWeight: 600 };

const PageTitle = ({ children, sx }: PageTitleProps) => (
  <Typography component="h2" sx={sx ? [TITLE_SX, ...(Array.isArray(sx) ? sx : [sx])] : TITLE_SX}>
    {children}
  </Typography>
);

export default PageTitle;
